// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import '../../shared/shell/strings'

export const Route = createFileRoute('/platform/system')({
  staticData: { screenId: 'ConsoleSystemScreen', access: 'any platform role' },
  component: ConsoleSystemScreen,
})

function ConsoleSystemScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid="ConsoleSystemScreen">
      <PageHeader title={t('shell.nav.system')} titleTestId="consoleSystem_titleValue" />
    </main>
  )
}
